import { render, staticRenderFns } from "./SubMenuCallCenter.vue?vue&type=template&id=6a63ed50&"
import script from "./SubMenuCallCenter.vue?vue&type=script&lang=js&"
export * from "./SubMenuCallCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports